import {
  object,
  string
} from "yup";

import "./schemas";

const authorisedVisitorTemporaryWorkerSchema = object({
  name: string()
    .trim()
    .required()
    .label("Name"),
  organisation: string()
    .trim()
    .required()
    .label("Organisation")
});

export default authorisedVisitorTemporaryWorkerSchema;
